module.exports = __webpack_public_path__ + "static/twelve-response.f53b45d3.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/twelve-response.webp
// module id = 925
// module chunks = 3